import { Button, Text, VStack } from "@chakra-ui/react"
import ErrorAlert from "../../../components/ErrorAlert"
import { useRunResortSnowReports } from "../../../hooks/useRunResortSnowReports"
import { extractErrorInfo } from "../../../lib/api/error-utils"

type Props = {
  resortUid: string
}

export default function RunSnowScraperButton({ resortUid }: Props) {
  const run = useRunResortSnowReports(resortUid)
  const errorInfo = run.error ? extractErrorInfo(run.error) : null

  return (
    <VStack align="start" gap="2">
      <Button
        size="sm"
        colorPalette="blue"
        loading={run.isPending}
        loadingText="Running scraper…"
        disabled={run.isPending}
        onClick={() => run.mutate()}
      >
        Run scraper now
      </Button>
      {run.isSuccess && (
        <Text role="status" fontSize="sm" color={run.data.Warning ? "orange.300" : "green.300"}>
          {run.data.Warning || "Scraper finished. Observation saved."}
        </Text>
      )}
      {errorInfo && (
        <ErrorAlert message={errorInfo.message} traceId={errorInfo.traceId} />
      )}
    </VStack>
  )
}
